const { register, submitGuest } = require("../components/loginHelpers");

/**
* Registers a user with their birthday information.
* This function calls the register function with a parameter indicating that the birthday should be included.
*/
function registerWithBirthday() {
    register(true);
}

module.exports = {
    register: registerWithBirthday,
    submitGuest: submitGuest
};
